<script>
    const poiTypes = ['arrival', 'departure'];
    const poiColors = ['#94d2bd', '#ee9b00'];
</script>

<svg id="legend" width={50} height={50}>
    <g font-size="10" font-family="sans-serif" text-anchor="begin">
        {#each poiTypes as type, i}
            <rect
                fill={poiColors[i]}
                x="0"
                y={i * 10 + 3}
                width="5"
                height="5"
            />
            <text x="7" y={i * 10 + 9} fill="currentColor">
                {type}
            </text>
        {/each}
    </g>
</svg>

<style>
    #legend {
        position: absolute;
        top: 10px;
        right: 0;
    }
</style>
